import { render, staticRenderFns } from "./Commodities.vue?vue&type=template&id=31b40a26"
import script from "./Commodities.vue?vue&type=script&lang=js"
export * from "./Commodities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports